import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as colors from '@atlaskit/theme/colors';
import { createTheme } from '@atlaskit/theme/components';
export var backgroundColors = {
  added: {
    light: colors.G50,
    dark: colors.G50
  },
  default: {
    light: colors.N40,
    dark: colors.DN70
  },
  important: {
    light: colors.R400,
    dark: colors.R400
  },
  primary: {
    light: colors.B400,
    dark: colors.B100
  },

  /* Note that primary inverted is a temporary implementation. Once navigation has
  context of the nav location to pass down, this will be moved to the primary when
  viewed in a global context. */
  primaryInverted: {
    light: colors.N0,
    dark: colors.DN400
  },
  removed: {
    light: colors.R50,
    dark: colors.R50
  }
};
export var textColors = {
  added: {
    light: colors.G500,
    dark: colors.G500
  },
  default: {
    light: colors.N800,
    dark: colors.DN900
  },
  important: {
    light: colors.N0,
    dark: colors.N0
  },
  primary: {
    light: colors.N0,
    dark: colors.DN0
  },
  primaryInverted: {
    light: colors.B500,
    dark: colors.DN0
  },
  removed: {
    light: colors.R500,
    dark: colors.R500
  }
};
export var Theme = createTheme(function (_ref) {
  var appearance = _ref.appearance,
      mode = _ref.mode;

  if (_typeof(appearance) === 'object') {
    return _objectSpread({
      backgroundColor: backgroundColors.default.light,
      textColor: textColors.default.light
    }, appearance);
  }

  return {
    backgroundColor: backgroundColors[appearance][mode],
    textColor: textColors[appearance][mode]
  };
});